import { createFileRoute } from "@tanstack/react-router";

import { EmployeeFormPage } from "@/components/employees/form";
import { RequirePermission } from "@/hooks/shared/CheckAuth";

export const Route = createFileRoute("/_main/dashboard/employees/$id/edit")({
  component: () => (
    <RequirePermission action="employees.update">
      <EmployeeFormPage />
    </RequirePermission>
  ),
});
